<template lang="pug">

	b-form-group(:label="_field.label" :description="_field.help")
		b-input-group
			b-input-group-prepend(v-if="_field.icon")
				b-input-group-text
					i(:class='_field.icon')
			multiselect(v-model="customVal" v-bind="_field.attrs" :multiple="false" label="title" track-by="title" :options="_field.options" :show-labels="false" @input="input")
				span(slot="noResult").
					Ничего не найдено!
			b-form-invalid-feedback {{ _invalidFeedback(_field.name) }}
</template>
<script>
	import Multiselect from 'vue-multiselect'

	export default {
		name: 'vue-multiselect',
		props: ['value', '_field', '_invalidFeedback', '_checkState'],
		data: ()=>({
		}),
		components: { Multiselect },
		computed: {
			customVal:{
				get(test){ return this._field.options.filter( item => console.log(test) || this.value === item.value )[0] },
				set(newVal){ return this._field.options.filter( item => console.log(newVal) || newVal.value === item.value )[0] }
			}
		},
		methods: {
			input($event){
				console.log($event);
				this.$emit('input', $event.value)
			}
		},
	}
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
